import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { SharedBarModule } from '../../components/shared-bar.module';
import { ResultsModule } from '../results/results.module';
import { ChatAnswerMessageComponent } from './components/chat-answer-message/chat-answer-message.component';
import { ChatEmptyStateComponent } from './components/chat-empty-state/chat-empty-state.component';
import { ChatFiltersBoxComponent } from './components/chat-filters-box/chat-filters-box.component';
import { ChatPageComponent } from './components/chat-page/chat-page.component';
import { ChatQuestionMessagesComponent } from './components/chat-question-message/chat-question-message.component';
import { ChatSidebarComponent } from './components/chat-sidebar/chat-sidebar.component';
import { ChatComponent } from './components/chat/chat.component';
import { ChatsService } from './services/chats.service';
import { chatErrorStateComponent } from './components/chat-error-state/chat-error-state.component';
import { ChatAssistantsService } from '../../services/chat-assistants.service';
import { ChatSidebarAssistantItem } from './components/chat-sidebar/chat-sidebar-assistant-item/chat-sidebar-assistant-item.component';
import { ChatSidebarSessionItem } from './components/chat-sidebar/chat-sidebar-session-item/chat-sidebar-session-item.component';
import { ChatsPopupService } from './services/chats-popup.service';
import { ChatTextareaComponent } from './components/chat-textarea/chat-textarea.component';
import { ChatFileService } from './services/chat-files.service';
import { ChatFileComponent } from './components/chat-file/chat-file.component';
import { ChatAssistantDropdownComponent } from './components/chat-assistant-dropdown/chat-assistant-dropdown.component';

const components = [
  ChatPageComponent,
  ChatComponent,
  ChatSidebarComponent,
  ChatSidebarAssistantItem,
  ChatSidebarSessionItem,
  ChatAnswerMessageComponent,
  ChatQuestionMessagesComponent,
  ChatFiltersBoxComponent,
  ChatEmptyStateComponent,
  chatErrorStateComponent,
  ChatTextareaComponent,
  ChatFileComponent,
  ChatAssistantDropdownComponent,
];

@NgModule({
  declarations: components,
  imports: [SharedModule, SharedBarModule, ResultsModule],
  exports: components,
  providers: [ChatsService, ChatAssistantsService, ChatsPopupService, ChatFileService],
})
export class ChatPageModule {}
